import Reveal from "../components/Reveal";

const QUESTIONS = [
  "Who do you serve?",
  "What problem do you solve?",
  "Why do customers choose you?",
  "What makes you different?",
  "What proof do you have?",
  "What should someone do after discovering you?",
];

export default function Discovery() {
  return (
    <section id="discovery" data-testid="discovery-section" className="relative py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="grid grid-cols-1 gap-14 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <Reveal>
              <p className="font-mono text-xs font-semibold tracking-[0.3em] text-gold">DISCOVERY FIRST</p>
              <h2 className="mt-5 font-display text-3xl font-bold leading-tight tracking-tight text-white sm:text-4xl">
                Before We Build Anything, We Listen.
              </h2>
              <p className="mt-6 text-base leading-relaxed text-slate-400">
                A great website doesn't begin with colors, fonts or code. It begins with understanding your business.
              </p>
              <div className="gold-hairline mt-8 h-px w-40" aria-hidden="true" />
            </Reveal>
          </div>
          <div className="lg:col-span-7">
            <ul className="grid grid-cols-1 gap-x-10 gap-y-6 sm:grid-cols-2">
              {QUESTIONS.map((q, i) => (
                <Reveal key={q} delay={i * 0.08}>
                  <li className="flex items-start gap-4 border-b border-navyline/60 pb-6">
                    <span className="mt-2 h-1.5 w-1.5 shrink-0 rotate-45 bg-gold" aria-hidden="true" />
                    <span className="font-display text-lg font-medium leading-snug text-slate-200">{q}</span>
                  </li>
                </Reveal>
              ))}
            </ul>
            <Reveal delay={0.4}>
              <p className="mt-10 font-display text-xl font-semibold leading-relaxed text-gold sm:text-2xl">
                Once we understand the story, we build the digital experience around it.
              </p>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
